import _ from 'lodash';
import getLocalReferential from '../Referential/getLocalReferential';
import logError from '../Error/postErrorForm';

function setPath(damage, segments) {
  const { zone, reconditionning, element } = damage;
  const { age, power, wheels_front, wheels_back } = segments;
  let path = '';
  if (zone.includes('servicing')) {
    path = `${zone}.${element}.${reconditionning}.${power}.${age}`;
  } else if (zone.includes('wheel') && zone.includes('back')) {
    path = `${zone}.${element}.${reconditionning}.${wheels_back}`;
  } else if (zone.includes('wheel')) {
    path = `${zone}.${element}.${reconditionning}.${wheels_front}`;
  } else {
    path = `${zone}.${element}.${reconditionning}.${power}`;
  }
  return path;
}

const listOfDuplicates = [
  ['wheels_front_left_tire_change', 'wheels_front_right_tire_change'],
  ['wheels_front_left_brake', 'wheels_front_right_brake'],
  ['wheels_back_right_tire_change', 'wheels_back_left_tire_change'],
  ['wheels_back_right_brake', 'wheels_back_left_brake'],
]; // damages that goes together, we keep only the max value - typicaly for right and left wheels we keep only max on 1 side
function removeDuplicates(damages) {
  const allElements = {};
  damages.forEach((damage) => {
    allElements[damage.element] = damage;
  });
  listOfDuplicates.forEach((couple) => {
    if (
      Object.prototype.hasOwnProperty.call(allElements, couple[0]) &&
      Object.prototype.hasOwnProperty.call(allElements, couple[1])
    ) {
      if (parseInt(allElements[couple[0]].cost, 10) > parseInt(allElements[couple[1]].cost, 10))
        delete allElements[couple[1]];
      else delete allElements[couple[0]];
    }
  });
  return Object.values(allElements);
}

export default async function applyReferential(damages, referentialName, segments, id, sourceName, sourceCall = null) {
  const referential = await getLocalReferential(referentialName);
  let refErrors = '';
  let MsgSourceCall = '';
  let quotedDamages = damages.map((damage) => {
    const quotedDamage = { ...damage }; // make a copy of the data
    quotedDamage.referential = referentialName;
    if (quotedDamage.is_custom) {
      // for custom damages, we remove tax from user manual price
      if (referentialName === 'psa_ht_cession') {
        let cost = 0;
        try {
          cost = Math.round(parseInt(quotedDamage.cost, 10) / 1.2);
        } catch (e) {
          // logError('warning', new Error('error_with_custom_cost_ht'), ['custom cost', 'ht value']);
        }
        quotedDamage.cost = cost;
      }
      return quotedDamage;
    }
    const path = setPath(quotedDamage, segments);
    if (path === '' || path === undefined) {
      refErrors += `undefined path ${path} ${JSON.stringify(quotedDamage)} \r\n `;
    }
    let cost = _.get(referential, path, undefined);
    if (cost === undefined) {
      cost = _.get(referential, path, undefined);
      if (cost === undefined) {
        if (referentialName === 'pautric_internal')
          // logError('warning', new Error('value_missing_in_referential', referentialName, path), [
          //   'referential',
          //   'value missing',
          // ]);
          refErrors += `missing value in referential : ${referentialName} with ${path} when we try to get cost for file ${id} of source ${sourceName} \r\n `;
        cost = 0;
      }
    }
    cost = _.parseInt(cost, 10);
    quotedDamage.cost = cost;
    return quotedDamage;
  });
  if (refErrors.length !== 0) {
    if (sourceCall !== null) MsgSourceCall = ` call from ${sourceCall}`;
    const bodyError = {
      error: `${refErrors} ${MsgSourceCall}`,
    };
    await logError(JSON.stringify(bodyError));
  }
  quotedDamages = removeDuplicates(quotedDamages);
  return quotedDamages;
}
